<template>
    <div class="noSideWrapper">
        <div class="noSide" :style="$route.meta.width?('max-width:'+$route.meta.width):''">
            <keep-alive>
                <router-view v-if="$route.meta.keepAlive"></router-view>
            </keep-alive>
            <router-view v-if="!$route.meta.keepAlive"></router-view>
        </div>
        <Footer :fixed="false" />
    </div>
</template>
<script>
import Footer from '@/components/assembly/Footer.vue'
export default {
    components: {
        Footer
    }
}
</script>
<style lang="scss" scoped>
.noSideWrapper {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
}
.noSide{
    width: 100%;
    padding: 0 40px;
    max-width: 1200px;
    margin: auto;
    flex: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/noSide.vue